import { schema } from 'normalizr';
import { RecruitmentApplication } from '../models/mentoring-program-recruitments';


export const RecruitmentApplicationSchema = new schema.Entity<RecruitmentApplication>('mentorshipProgramRecruitmentApplications');

export const RecruitmentApplicationsSchema = new schema.Array(
  RecruitmentApplicationSchema,
);
